import React from 'react';
import { Outlet } from 'react-router-dom';

const RespuestasLayout = () => <Outlet />;

export default RespuestasLayout;
